/**
 * Unified component creation logic
 * Routes to appropriate component creator based on section type
 */
import { IBotSection } from '../../../models';
import { SectionCreationContext } from '../../../models/bot';
import { createFilterComponent } from './createFilter';
import { createCoilComponent } from './createCoil';

/**
 * Creates component for a section (filter or coil)
 * Note: This is a simplified version for bot creation.
 * Full configuration (rating, sizing, etc.) may need to be done separately.
 */
export async function createSectionComponent(
  botSection: IBotSection,
  sectionId: number,
  context: SectionCreationContext,
  modelData: any,
): Promise<void> {
  if (!botSection.type || botSection.type === 'plenum') {
    return;
  }

  if (botSection.type === 'filter' && botSection.type_id) {
    await createFilterComponent(botSection, sectionId, context, modelData);
  } else if (botSection.type === 'coil' && botSection.duty_id) {
    await createCoilComponent(botSection, sectionId, context, modelData);
  } 
}
